module.exports = __webpack_public_path__ + "img/logo.ff730d4d.png";